import { useEffect, useRef, useState } from 'react';

export function useElementWidth() {
  const ref = useRef<HTMLInputElement | null>(null);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return { ref, width };
}
